/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from '@app/app.module';
import { initSentry } from '@app/sentry';
import { environment } from '@env/environment';

if (environment.production) {
  enableProdMode();
}

// Sentry initialisieren (No-op, wenn keine SENTRY_DSN gesetzt ist).
initSentry();

platformBrowserDynamic().bootstrapModule(AppModule, {})
  .catch(err => console.error(err));
